<template>
    <!-- 10月激励在线 -->
    <div class="ranking">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad" :error.sync="error" error-text="" :immediate-check="false">
            <div v-for="(v, k) in jobTabs" :key="k">
                <div v-if="currentJobTab == k + 1">
                    <!-- banner -->
                    <img class="banner" :src="`https://staticwecom.beautyfarm.com.cn/2025-09-25/${v.bannerImg}.png`" alt="banner">
                    <!-- <span :class="['rule', ` rule${currentJobTab}`]" @click="toRule"> 活动规则 </span> -->
                    <!-- <img class=" rule" @click="showRule = true" :src="`${v.url}2025-02-18/${v.ruleImg}.png`"> -->
                    <!-- 奖品 -->
                    <div class="reward-box">
                        <div class="bear-palm" v-if="currentJobTab === '1'">
                            <p>获奖奖品</p>
                            <div class="reward-list" v-if="currentMoldTab === '核心护理销售激励'">
                                <div class="left">
                                    <p>销售≥50，获得<span>3800元</span>奖金</p>
                                    <p>40≤销售{{ '<' }}50，获得<span>2800元</span>奖金</p>
                                    <p>30≤销售{{ '<' }}40，获得<span>1500元</span>奖金</p>
                                    <p>20≤销售{{ '<' }}30，获得<span>800元</span>奖金</p>
                                    <p>10≤销售{{ '<' }}20，获得<span>300元</span>奖金</p>
                                </div>
                                <div class="right">
                                    <img :src="`https://staticwecom.beautyfarm.com.cn/2025-09-25/money.png`" alt="right image">
                                </div>
                            </div>
                            <div class="reward-list" v-if="currentMoldTab === '本宫系列护理激励'">
                                <div class="left two">
                                    <p>活动结束销售额</p>
                                    <p>全国TOP50获得<span>激励盲盒1套</span></p>
                                </div>
                                <div class="right imgTwo">
                                    <img :src="`https://staticwecom.beautyfarm.com.cn/2025-09-25/boxes.png`" alt="right image">
                                </div>
                            </div>
                            <div class="stay">*待活动结束后兑付奖品</div>
                        </div>
                        <div class="bear-palm director" v-else>
                            <p>获奖奖品</p>
                            <div class="reward-list">
                                <div class="left">
                                    <img :src="`https://staticwecom.beautyfarm.com.cn/2025-09-25/${v.leftImg}.png`" alt="right image">
                                    <p>截止10/26 24:00前 </p>
                                    <p>区域权益金100%达标</p>
                                    <p>且收入在进度90%以上</p>
                                </div>
                                <div class="right">
                                    <img :src="`https://staticwecom.beautyfarm.com.cn/2025-09-25/${v.rightImg}.png`" alt="right image">
                                    <p>截止10/28 24:00前 </p>
                                    <p>区域权益金100%达标</p>
                                    <p>且收入在进度97%以上</p>
                                </div>
                            </div>
                            <div class="stay">*待活动结束后兑付奖品</div>
                        </div>
                        <div v-if="!loading">

                            <img v-if="!myFlag" class="reward-status" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/2025-02-18/award-status1.png">
                            <template v-else>
                                <img v-if="!isEnd && !isAward" class="reward-status" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/2025-02-18/award-status2.png">
                                <img v-if="!isEnd && isAward" class="reward-status" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/2025-02-18/award-status33.png">
                                <img v-if="isEnd && !isAward" class="reward-status" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/2025-02-18/award-status4.png">
                                <img v-if="isEnd && isAward" class="reward-status" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/2025-02-18/award-status5.png">
                            </template>

                            <template v-if="myFlag">
                                <div class="compare" v-if="currentJobTab === '1'">
                                    <div class="compare-data">
                                        <p>我的</p>
                                        <p>{{ currentMoldTab === '核心护理销售激励' ? '热养嫩肤系列销售额' : '本宫系列护理销售额' }}</p>
                                        <p class="blue">
                                            {{ currentMoldTab === '核心护理销售激励' ? myInfo.rynfSaleAmt : myInfo.bghlSaleAmt }}<span>W</span>
                                        </p>
                                    </div>
                                    <img v-if="currentMoldTab === '本宫系列护理激励'" class="less" :src="`https://staticwecom.beautyfarm.com.cn/wecom-workbench/2025-02-18/${compare()}.png`">
                                    <div class="compare-data">
                                        <p>{{ currentMoldTab === '核心护理销售激励' ? '我的' : '第50名客户经理' }}</p>
                                        <p>{{ currentMoldTab === '核心护理销售激励' ? '本宫系列护理销售额' : '本宫系列护理销售额' }}</p>
                                        <p class="red">
                                            {{ currentMoldTab === '核心护理销售激励' ? myInfo.bghlSaleAmt : dataInfo.fiftyAmt }}<span>W</span>
                                        </p>
                                    </div>
                                </div>
                                <div class="compare" v-else>
                                    <div class="compare-data">
                                        <p>{{ currentJobTab === '2' ? '我的门店' : '我的区域' }}</p>
                                        <p>当前权益金</p>
                                        <p class="blue">
                                            {{ myInfo.accountAmtMtd }}<span>W</span>
                                            <span class="red fs-32">({{ myInfo.accountAmtTargetPer }}%)</span>
                                        </p>
                                    </div>
                                    <img v-if="currentMoldTab === '本宫系列护理激励'" class="less" :src="`https://staticwecom.beautyfarm.com.cn/wecom-workbench/2025-02-18/${compare()}.png`">
                                    <div class="compare-data">
                                        <p>{{ currentJobTab === '2' ? '我的门店' : '我的区域' }}</p>
                                        <p>当前营业收入</p>
                                        <p class="blue">
                                            {{ myInfo.netAmtMtd }}<span>W</span>
                                            <span class="red fs-32">({{ myInfo.netAmtTargetPer }}%)</span>
                                        </p>
                                    </div>
                                </div>
                            </template>
                        </div>
                        <p class="update-time">{{ getTheme() }} {{ today }}{{ hour }}点</p>
                    </div>

                    <div :class="[currentJobTab == 1 ? 'bg-color' : 'bg-color-two']"></div>
                </div>
            </div>
            <div class="ranking-box">
                <div class="ranking-box-hd">
                    <div :class="{ on: isStore === 1 }" @click="onTabChange(1)">全部</div>
                    <div :class="{ on: isStore === 2 }" @click="onTabChange(2)">本店</div>
                </div>
                <div class="tabs-box">
                    <div class="job-tabs">
                        <!--    第一层     -->
                        <div class="between">
                            <div class="job-tab-item" v-for="(it, ind) in jobTabs" :key="ind" :class="{ on: currentJobTab == it.dictValue }" @click="onJobTab(it)">
                                {{ it.dictLabel }}
                            </div>
                        </div>
                        <!--    第二层     -->
                        <!-- <div class="top53">
                            <div class="group-tab-item" :class="{ on: currentGroupTab == j.dictValue }" v-for="(j, n) in jobTabs[currentJobTab - 1].groupTabs" :key="n" @click="onGroupTab(j)">
                                {{ j.dictLabel }}
                            </div>
                        </div> -->
                        <!--    第三层     -->
                        <div>
                            <div class="new-group-tab-item" :class="{ on: currentMoldTab == j, nextOn: currentJobTab == 2 && currentMoldTab == j }" v-for="(j, n) in jobTabs[currentJobTab - 1].moldTabs" :key="n" @click="onMoldTab(j)">
                                {{ j }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="ranking-list-box">
                    <div class="table-container">
                        <FixedColumnTable :columns="jobTabs[Number(currentJobTab) - 1].columns" :data="list" :myInfo="myInfo" :myFlag="myFlag" :currentMoldTab="currentMoldTab" :currentJobTab="currentJobTab" />
                    </div>
                </div>
            </div>
        </van-list>
    </div>
</template>

<script>
    import request from '@/utils/request'
    import FixedColumnTable from './FixedColumnTable.vue';
    import { debounce } from 'lodash';
    import { Toast } from 'vant'

    export default {
        name: 'ssRankList',
        components: {
            FixedColumnTable
        },
        computed: {
            // rank() {
            //     return function (item) {
            //         if (this.currentJobTab == 1) {
            //             return item.rnk
            //         }
            //         if (this.currentJobTab == 2 && this.currentGroupTab == 1) {
            //             return item.nxRnk
            //         }
            //         if (this.currentJobTab == 2 && this.currentGroupTab == 2) {
            //             return item.saleRnk
            //         }
            //     }
            // },
        },
        data() {
            return {
                showRule: false, // 是否显示规则弹窗
                myFlag: false, // 是否显示我的
                jobTabs: [
                    {
                        dictLabel: '客户经理', dictValue: '1',
                        moldTabs: ['核心护理销售激励', '本宫系列护理激励'],
                        "bgColor": "#FFE68F",
                        "url": "https://staticwecom.beautyfarm.com.cn/wecom-workbench/",
                        "bannerImg": "bannerjl",
                        "rightImg": "money",
                        jobtab: '',
                        columns: [{
                            title: '排名',
                            key: 'hxhlRnk',
                            width: '40px'
                        },
                        {
                            title: '客户经理',
                            key: 'employeeName',
                            width: '140px'
                        },
                        {
                            title: '核心护理销售额',
                            key: 'hxhlSaleAmt',
                            width: '130px'
                        },
                        {
                            title: '预计奖金',
                            key: 'awardAmt',
                            width: '100px'
                        }]
                    },
                    {
                        dictLabel: '主任', dictValue: '2',
                        moldTabs: ['成熟四五阶段', '成熟二三阶段', '成熟第一阶段', '成长', '新店'],
                        "bgColor": "#8B020F",
                        "url": "https://staticwecom.beautyfarm.com.cn/wecom-workbench/",
                        "bannerImg": "bannerzr",
                        "leftImg": "money1000",
                        "rightImg": "money500",
                        jobtab: '',
                        columns: [{
                            title: '排名',
                            key: 'accountAmtRnk',
                            width: '40px'
                        },
                        {
                            title: '主任',
                            key: 'employeeName',
                            width: '140px'
                        }, {
                            title: '预计获得奖金',
                            key: 'awardAmt',
                            width: '120px'
                        },
                        {
                            title: '权益金',
                            key: 'accountAmtMtd',
                            width: '120px'
                        },
                        {
                            title: '权益金达成率',
                            key: 'accountAmtTargetPer',
                            width: '120px'
                        },
                        {
                            title: '营业收入',
                            key: 'netAmtMtd',
                            width: '100px'
                        },
                        {
                            title: '营业收入达成率',
                            key: 'netAmtTargetPer',
                            width: '125px'
                        }]
                    },
                    {
                        dictLabel: '区经', dictValue: '3',
                        moldTabs: ['第一组', '第二组', '第三组'],
                        "bgColor": "#8B020F",
                        "bannerImg": "bannerqj",
                        "leftImg": "money2000",
                        "rightImg": "money1000",
                        "rewardImg": "naxinxiaoshouhuojiang",
                        jobtab: '',
                        columns: [{
                            title: '排名',
                            key: 'accountAmtRnk',
                            width: '40px'
                        },
                        {
                            title: '主任',
                            key: 'employeeName',
                            width: '140px'
                        }, {
                            title: '预计获得奖金',
                            key: 'awardAmt',
                            width: '120px'
                        },
                        {
                            title: '权益金',
                            key: 'accountAmtMtd',
                            width: '120px'
                        },
                        {
                            title: '权益金达成率',
                            key: 'accountAmtTargetPer',
                            width: '120px'
                        },
                        {
                            title: '营业收入',
                            key: 'netAmtMtd',
                            width: '100px'
                        },
                        {
                            title: '营业收入达成率',
                            key: 'netAmtTargetPer',
                            width: '125px'
                        }]
                    }], // 职位分类标签列表
                currentJobTab: '1',
                groupNoList: ['', ''],
                myInfo: {},
                groupTabs: [{ dictLabel: '超声炮', dictValue: '1' }, { dictLabel: '超V脸', dictValue: '2' }], // 分组标签列表
                currentGroupTab: '1', // 当前选中的分组
                currentMoldTab: '核心护理销售激励', // 当前选中第三层分组
                loading: true, // 是否正在加载
                finished: false, // 是否加载完成
                isAward: false, // 是否获奖
                isReach: false, // 是否达到目标
                today: new Date().getMonth() + 1 + '月' + new Date().getDate() + '日', // 当前日期，格式为"月日"
                hour: new Date().getHours(), // 当前小时数
                isEnd: new Date().getTime() > new Date('2025-10-31 23:59:59').getTime(), // 活动是否已结束
                list: [], // 排名列表数据
                isStore: 1, // 当前选中的tab
                page: 0, // 当前页码
                error: false, // 是否发生错误
                contrastData: 0, // 对比数据，用于与当前用户数据进行对比
                myData: 0,// 当前用户的数据，用于展示用户自身排名信息
                // 员工id列表, 分别对应[ '客户经理', '主任', '区经']
                postIdList: [['2', '42'], ['1'], ['11', '1472787652026765457', '1472787652026765732']],
                dataInfo: {},
                empNo: '',
                role: '',
                getListInterval: null // 轮询定时器
            }
        },

        created() {

        },

        mounted() {

            this.getUserLogin()
            // 设置10分钟(600,000毫秒)轮询一次数据
            this.getListInterval = setInterval(this.IntervalList, 600000);
        },

        beforeDestroy() {
            // 组件销毁前清除定时器
            if (this.getListInterval) {
                clearInterval(this.getListInterval);
            }
        },

        methods: {

            IntervalList() {
                console.log('IntervalList')
                this.page = 0
                this.finished = false
                this.getDataList()
            },

            compare() {
                return Number(this.myInfo.bghlSaleAmt) > Number(this.dataInfo.fiftyAmt) ? 'more' : this.myInfo.bghlSaleAmt === this.dataInfo.fiftyAmt ? 'equal' : 'less'
            },
            getTheme() {
                let msg = this.currentJobTab !== '1' ? '权益金、营业收入数据更新时间' : this.currentMoldTab === '核心护理销售激励' ? '核心护理销售额数据更新时间' : '本宫系列护理销售额数据更新时间'
                return msg
            },
            //员工基本信息
            getUserLogin() {
                return request({
                    url: "/my/getUserLogin",
                    method: "get",
                })
                    .then((res) => {
                        this.role = ''
                        this.empNo = res.data.empNo;
                        this.postIdList.forEach((it, i) => {
                            if (it.includes(res.data.postId)) {
                                this.role = i + 1 + ''
                            }
                        })
                        if (!this.role) {
                            this.$dialog.alert({
                                title: '提示',
                                message: '当前用户暂无权限, 请返回',
                            }).then(() => {
                                this.$router.back()
                            });
                            return
                        }
                        if (this.role === '1') {
                            this.isEnd = new Date().getTime() > new Date('2025-11-05 23:59:59').getTime()
                        } else {
                            this.isEnd = new Date().getTime() > new Date('2025-10-31 23:59:59').getTime()
                        }
                        this.currentJobTab = this.role
                        this.jobTabs = this.jobTabs.slice(0, Number(this.role))

                        this.currentMoldTab = this.jobTabs[this.currentJobTab - 1].moldTabs[0] // 默认选中

                        this.getDataList()
                    })
                    .catch((error) => {
                        Toast({ position: "top", message: error ?? "" });
                    });
            },
            // 切换全部/本店标签
            onTabChange(value) {
                if (this.isStore === value) return
                if (this.role === '3') {
                    this.$toast('区经无法选择本店!')
                    return
                }
                this.isStore = value;
                this.finished = false
                this.error = false;
                this.page = 0

                this.getDataList()
            },
            // 初始化数据，获取销售列表
            getDataList: debounce(async function () {
                console.log('getDataList2', this.finished)
                Toast.loading({
                    forbidClick: true,
                    duration: 0
                });
                this.hour = new Date().getHours() // 当前小时数
                if (this.finished) return
                let currentMoldTab = this.currentMoldTab === '第一组' ? '第1组' : this.currentMoldTab === '第二组' ? '第2组' : this.currentMoldTab === '第三组' ? '第3组' : this.currentMoldTab
                try {
                    const params = {
                        groupNo: this.currentJobTab === '1' ? '' : currentMoldTab,
                        empType: this.currentJobTab,
                        // mold: this.currentGroupTab,this.empNo
                        pageNum: this.page,
                        employeeId: this.empNo, // 客户经理82330  区域经理80288  主任82112
                        prodType: this.currentMoldTab === '核心护理销售激励' ? '1' : this.currentMoldTab === '本宫系列护理激励' ? '2' : '',
                        dataType: this.isStore,
                        pageSize: 10
                    }
                    const { code, msg, data } = await request({
                        // url: '/motivate/getList',
                        url: 'octoberRank/getOctoberRank',
                        method: 'get',
                        params
                    })
                    if (code !== 0) {
                        throw new Error(msg)
                    }
                    Toast.clear();
                    // 对应jobTabs中的dataInfo赋值
                    this.dataInfo = data
                    this.myFlag = data && data.myFlag === 1 ? true : false
                    if (this.currentJobTab === '1') {
                        let isAwardHx = data && data.myFlag && data.saleData && data.saleData.awardAmt && data.saleData.awardAmt > 0 ? true : false
                        let isAwardBz = data && data.myFlag && data.saleData && data.saleData.isAward == '是' ? true : false
                        this.isAward = this.currentMoldTab === '核心护理销售激励' ? isAwardHx : isAwardBz
                    } else if (this.currentJobTab === '2') {
                        this.isAward = data && data.myFlag && data.saleData && data.saleData.targetGet1026 == '是' ? true : false
                    } else {
                        this.isAward = data && data.myFlag && data.saleData && data.saleData.targetGet1028 == '是' ? true : false
                    }
                    if (data.saleData) {
                        data.saleData.groupNo = data.saleData.groupNo === '第1组' ? '第一组' : data.saleData.groupNo === '第2组' ? '第二组' : data.saleData.groupNo === '第3组' ? '第三组' : data.saleData.groupNo
                    }
                    this.currentMoldTab = this.currentJobTab !== '1' && data && data.myFlag && data.saleData ? data.saleData.groupNo : this.currentMoldTab  // 默认选中
                    // 对赌激励取cspPkList ，销售纳新取cspMmbList
                    const list = data && data.saleList
                    this.myInfo = data && data.saleData
                    if (this.page == 0) {
                        this.list = list
                    } else {
                        this.list = this.list.concat(list)
                    }
                    this.page += 1
                    this.loading = false;

                    if (list.length < 10) {
                        this.finished = true;
                    }
                } catch (error) {
                    this.loading = false;
                    this.list = []
                    this.error = true;
                    this.myFlag = false
                    this.$toast(error)
                }

            }, 500),
            onLoad() {
                this.getDataList()
            },
            // 切换职位分类标签
            onJobTab(value) {
                this.currentJobTab = value.dictValue;
                this.currentGroupTab = '1'
                this.page = 0
                this.finished = false
                this.error = false;
                this.isStore = 1
                this.currentMoldTab = this.jobTabs[this.currentJobTab - 1].moldTabs[0]
                if (this.currentJobTab === '1') {
                    this.currentMoldTab = '核心护理销售激励'
                    this.onMoldTab('核心护理销售激励')
                }
                this.getDataList()
            },
            // 切换分组标签
            onGroupTab(v) {
                this.currentGroupTab = v.dictValue;
                this.finished = false
                this.error = false;
                this.page = 0
                this.getDataList()
            },
            // 切换第三层分组
            onMoldTab(v) {
                this.currentMoldTab = v;
                this.finished = false
                this.error = false;
                this.page = 0
                if (v === '本宫系列护理激励') {
                    this.jobTabs[0].columns = [{
                        title: '排名',
                        key: 'bghlRnk',
                        width: '40px'
                    },
                    {
                        title: '客户经理',
                        key: 'employeeName',
                        width: '140px'
                    },
                    {
                        title: '本宫系列护理销售额',
                        key: 'bghlSaleAmt',
                        width: '200px'
                    }]
                } else {
                    this.jobTabs[0].columns = [{
                        title: '排名',
                        key: 'hxhlRnk',
                        width: '40px'
                    },
                    {
                        title: '客户经理',
                        key: 'employeeName',
                        width: '140px'
                    },
                    {
                        title: '核心护理销售额',
                        key: 'hxhlSaleAmt',
                        width: '130px'
                    },
                    {
                        title: '预计奖金',
                        key: 'awardAmt',
                        width: '100px'
                    }]
                }
                this.getDataList()
            },
            toRule() {
                this.$router.push({ path: '/newRankingRules', query: { currentJobTab: this.currentJobTab } })
            }
        }
    }
</script>

<style lang='less' scoped>
    .ranking {
        position: relative;
        height: 100%;
        font-size: 28px;
        overflow-y: scroll;
        color: #333333;
        background-color: #fff;
    }

    .mmbMum-box {
        margin: 40px 0;
        margin-bottom: 20px;

        .mmbMum-title {
            font-size: 24px;
        }

        .mmbMum {
            color: #0072FF;
            font-size: 46px;
            margin: 38px 0 40px 0;
            font-weight: bold;
        }

        .avtive-top-38 {
            margin-top: 38px;
            display: flex;
            align-items: center;
            justify-content: center;

            .left {
                font-weight: bold;
                font-size: 46px;
                color: #0072FF;
            }

            .right {
                margin-left: 20px;
                font-weight: bold;
                font-size: 30px;
                color: #0072FF;
            }

            .saleJune {
                font-weight: bold;
                font-size: 46px;
                color: #0072FF;
            }
        }

        .top-38 {
            margin-top: 38px;
            display: flex;
            align-items: center;
            justify-content: center;

            .left {
                font-weight: bold;
                font-size: 46px;
                color: #D62C18;
            }

            .right {
                margin-left: 20px;
                font-weight: bold;
                font-size: 30px;
                color: #D62C18;
            }

            .saleJune {
                font-weight: bold;
                font-size: 46px;
                color: #0072FF;
            }
        }
    }

    .myWrapper {
        padding: 20px;
    }

    .banner {
        width: 100%;
        height: 464px;
    }

    .rule {
        position: absolute;
        width: 120px;
        top: 50px;
        right: 0;
        width: 120px;
        height: 61px;
        line-height: 61px;
        font-size: 26px;
        text-align: center;
        color: #ffffff;
        background: #D22E28;
        border-top-left-radius: 31px;
        border-bottom-left-radius: 31px;
        // padding: 10px 0;
    }

    .rule1,
    .rule2 {
        background: #DBC7C1;
    }

    .rule3 {
        background: #DBC7C1;
    }

    .reward-box {
        position: relative;
        width: 100%;
        margin-top: -94px;
        padding: 30px;
        text-align: center;
        background-color: #fff;
        border-radius: 40px;
        z-index: 9;

        .reward-status {
            width: 100%;
            margin-top: 30px;
        }

        .bear-palm {
            width: 100%;
            background: #FFF7E7;
            border-radius: 50px;
            text-align: initial;
            padding: 0 37px;
            font-size: 24px;
            color: #666666;
            padding-bottom: 20px;
            height: 417px;
            position: relative;

            p {
                margin: 0;
                font-size: 24px;
            }

            .stay {
                font-size: 18px;
                color: #333333;
                text-align: center;
                position: absolute;
                left: 50%;
                transform: translateX(-50%);
                bottom: 20px;
            }

            .reward-item {
                display: flex;
                width: 100%;
                margin-top: 20px;

                p {
                    width: 120px;
                }

                p:nth-child(2) {
                    flex: 1;
                }
            }

            >p {
                width: 325px;
                height: 70px;
                background: #FFE19F;
                border-radius: 0px 0px 40px 40px;
                margin: 0 auto;
                text-align: center;
                font-weight: bold;
                font-size: 36px;
                color: #333333;
                line-height: 70px;
            }

            .reward-list {
                display: flex;
                align-items: center;
                justify-content: space-around;
                width: 100%;
                margin-top: 40px;
                color: #333333;

                >div {
                    text-align: center;

                    img {
                        width: 107px;
                    }
                }

                .right {
                    text-align: right;
                }

                .imgTwo {
                    img {
                        width: 207px;
                    }
                }

                .left {
                    font-size: 30px;

                    p {
                        margin-bottom: 5px;
                        font-size: 26px;
                        text-align: left;

                        span {
                            color: #D41D16;
                            font-size: 30px;
                        }
                    }
                }

                .two {
                    p {
                        text-align: center;
                    }
                }
            }
        }

        .director {
            background: #F6F2FF;
            height: 454px;

            >p {
                width: 325px;
                height: 70px;
                background: #A67BDD;
                border-radius: 0px 0px 40px 40px;
                margin: 0 auto;
                text-align: center;
                font-weight: bold;
                font-size: 36px;
                color: #fff;
                line-height: 70px;
                text-shadow: 1px 3px 0px rgba(60, 0, 94, 0.52);
            }

            .reward-list {

                >div {
                    text-align: center;

                    img {
                        width: 140px;
                    }
                }

                .right {
                    text-align: right;
                }

                .left {
                    p {
                        margin-bottom: 5px;
                        font-size: 26px;
                        text-align: center;
                        color: #333333;
                    }
                }
            }
        }
    }

    .reward {
        display: flex;
        align-items: center;
        justify-content: space-around;
        width: 100%;
        height: 100%;
        // padding-bottom: 30px;
        // padding-top: 80px;
        margin-bottom: 30px;
        // background-image: url('https://staticwecom.beautyfarm.com.cn/wecom-workbench/20250618/bg.png');
        background-size: 100% 100%;

        // &.left {
        //     padding-right: 30px;
        //     padding-left: 20px;
        // }
        >div {
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .horizantalBox {
            padding: 80px 108px 30px 108px;
        }

        .columnBox {
            align-items: flex-end;
        }

        .reward-data {
            flex-grow: 1;
            flex-shrink: 0;
            text-align: center;
            width: 50%;

            >img {
                height: 150px;
            }

            >div {
                font-size: 36px;
            }

            .fontRed {
                color: #D41D16;
                font-size: 42px;
                font-weight: bold;
            }

            &:first-of-type {
                width: 60%;
            }
        }

        .reward-data-column {

            >div {
                font-size: 36px;
                padding-top: 10px;
            }

            .fontRed {
                color: #D41D16;
                font-size: 42px;
                font-weight: bold;
            }

            img {
                height: 150px;
                vertical-align: sub;
                padding-left: 75px;
            }
        }


    }

    .reward2 {
        height: 100%;
    }

    .compare {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 30px 0;

        .less {
            width: 40px;
            height: 40px;
        }

        .compare-data {
            width: 45%;

            p {
                margin-bottom: 10px;
            }

            p:first-child {
                font-size: 36px;
            }

            p:nth-child(2) {
                font-size: 24px;
            }

            p:last-child {
                font-size: 46px;
                font-weight: 500;
            }
        }
    }

    .update-time {
        font-size: 24px;
        color: #999999;
        margin-top: 20px;
        margin-bottom: 0;
    }

    .fs-32 {
        font-size: 32px;
    }

    .blue {
        color: #007AFF;
        font-weight: 500;
    }

    .ranking-box {
        overflow: hidden;
        background-color: #fff;
        border-radius: 40px 40px 0 0;
    }

    .ranking-box-hd {
        display: flex;
        position: relative;

        >div {
            width: 50%;
            line-height: 100px;
            font-size: 36px;
            font-weight: 500;
            text-align: center;
            color: #999999;
            background-color: #F5F5F5;

            &.on {
                color: #333333;
                background-color: #ffffff;
            }
        }
    }

    .tabs-box {
        padding: 0 30px;
    }

    .between {
        display: flex;
        align-items: center;
        padding: 0;
    }

    .job-tabs {
        // display: flex;
        margin: 20px 0 30px 0;

        >div {
            display: flex;
            overflow-x: auto;
            overflow-y: hidden;
            white-space: nowrap;
        }

        .top53 {
            margin-top: 33px;
            padding: 0 21px;
            display: flex;
            justify-content: space-between;
            align-items: center;
        }
    }

    .job-tab-item {
        color: #999999;
        font-size: 30px;
        margin: 10px 0px 29px 0;
        font-weight: 500;
        text-align: center;
        border-radius: 30PX;
        position: relative;
        margin-right: 50px;

        &.on {
            color: #333333;
            font-weight: bold;

            // background-color: #DAA55F;
            // color: #ffffff;
            &::before {
                position: absolute;
                content: '';
                left: 50%;
                bottom: -15px;
                width: 40px;
                height: 6px;
                transform: translate(-50%);
                background-color: #333333;
                border-radius: 4px;
            }
        }
    }

    .group-tabs {
        display: flex;
        align-items: center;
        margin-bottom: 30px;
    }

    .new-group-tab-item {
        height: 40px;
        margin-right: 30px;
        line-height: 40px;
        text-align: center;
        font-size: 26px;
        color: #333333;
        background-color: #E6E6E6;
        border-radius: 20px;
        padding: 0 20px;

        &.on {
            color: #ffffff;
            font-weight: bold;
            background-color: #DBC7C1;
        }

        &.nextOn {
            color: #ffffff;
            font-weight: bold;
            background-color: #DBC7C1;
        }
    }

    .group-tab-item {
        text-align: center;
        color: #999999;
        font-size: 30px;
        border-radius: 20px;

        &.on {
            font-weight: bold;
            font-size: 30px;
            color: #333333;
        }
    }

    .group-tab-item {
        width: 120px;
        height: 40px;
        margin-right: 30px;
        line-height: 40px;
        text-align: center;
        font-size: 26px;
        color: #333333;
        background-color: #E6E6E6;
        border-radius: 20px;

        &.on {
            color: #ffffff;
            background-color: #AB080B;
        }
    }

    .ranking-list-box {
        border-top: 2px solid #eeeeee;
    }

    .ranking-list-item-box {
        padding: 0 20px;
    }

    .table-container {
        padding: 30px 20px;
    }

    .ranking-list-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        // margin: 10px 0;
        padding: 30px 40px;
        border-bottom: 2px solid #eeeeee;

        &.title {
            padding-bottom: 0;
            border: none;
            color: #999999;
        }
    }

    .ranking-num {
        width: 70px;
        margin-right: 40px;
        text-align: center;

        .color-red {
            color: #AB080B;
        }

        >img {
            width: 50px;
            height: 60px;
        }
    }

    .ranking-name {

        flex: 2.5;
        display: flex;
        align-items: center;
        width: 260px;

        >.img {
            width: 60px;
            height: 60px;
            margin-right: 10px;
        }

    }

    .ranking-order {
        flex: 1.2;
        text-align: center;
    }

    .ranking-bonus {
        flex: 1.8;
        text-align: center;
    }



    .popup-rule {
        width: 650px;
        padding-bottom: 30px;
        background-color: #fff;
        border-radius: 16px;
        overflow: hidden;
    }

    .popup-rule-hd {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 120px;
        font-size: 36px;
        font-weight: 500;
        background-image: linear-gradient(#CEDBF0, #ffffff);
    }

    .popup-main {
        height: 600px;
        overflow-y: scroll;

        >.title {
            padding: 20px 40px;
            font-size: 28px;
            font-weight: 500;
        }

        >.describe {
            padding: 0 60px;
            font-style: 24px;
            color: #66757F;
            line-height: 46px;
        }
    }

    .popup-close {
        position: absolute;
        left: 50%;
        bottom: -90px;
        transform: translate(-50%);
    }

    .bg-color {
        height: 90px;
        margin: -30px 0;
        background-color: #F3DAA2;
    }

    .bg-color-two {
        height: 90px;
        margin: -30px 0;
        background-color: #A67BDD;
    }

    .cityWrapper {
        padding: 20px 0;

        .cityBox {
            display: flex;
            align-items: center;

            .position {
                width: 23px;
                height: 28px;
                margin-left: 20px;
            }

            .arrow {
                width: 10px;
                height: 18px;
            }

            >span {
                padding: 0 15px;
            }
        }
    }
</style>
<style lang="less">
    .ranking {
        .red {
            color: #D41D16;
            font-weight: 500;
        }

        .van-popup {
            overflow-y: visible;
        }

        .van-image__error {
            background-color: #A1A1A1;
        }

        .van-list__finished-text,
        .van-list__loading,
        .van-list__error-text {
            margin-top: -2px;
            background-color: #fff;
        }
    }
</style>
